import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from '../components/file-upload.component';
import { FileUploadService } from '../services/file-upload.service';
import { FormsModule }    from '@angular/forms';

/** AngularMaterial **/
import {  MatButtonModule, MatIconModule,  MatRadioModule, MatProgressBarModule,  MatSnackBarModule,  MatDialogModule } from '@angular/material';

import { HttpService } from 'ems-oauth2-client';


/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MdAutocompleteModule, MdCheckboxModule, MdInputModule, MdRadioModule, MdSelectModule, MdSliderModule, MdSlideToggleModule, MdMenuModule, MdSidenavModule, MdToolbarModule, MdListModule, MdGridListModule, MdCardModule, MdTabsModule, MdButtonModule, MdButtonToggleModule, MdChipsModule, MdIconModule, MdProgressSpinnerModule, MdDialogModule, MdTooltipModule, MdSnackBarModule
**/

@NgModule({
    declarations: [
      FileUploadComponent
    ],
    exports: [
      FileUploadComponent
    ],
    imports: [
      FormsModule, CommonModule,
      MatButtonModule,   MatIconModule,   MatProgressBarModule,  MatSnackBarModule,  MatDialogModule
    ],
    providers: [
      FileUploadService, HttpService
    ]
})
export class FileUploadModule {
}
